<template>
  <BaseDialog :isOpen="true">
    <template v-slot:title>
      Are you sure you want to delete the {{ currentTalentPool.name }} talent
      pool?
    </template>
    <template v-slot:body>
      <div class="secondary-text">
        This can’t be undone.
      </div>
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="close" text>
          Cancel
        </PrimaryButton>
        <ErrorButton @click.native="handleSubmit" :loading="isLoading">
          Delete Talent Pool
        </ErrorButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { TALENT_POOLS_NAMESPACE } from "@/store/modules/talentPools";
import { REMOVE_TALENT_POOL } from "@/store/modules/talentPools/actions";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers(
  TALENT_POOLS_NAMESPACE
);

export default {
  name: "RemoveTalentPoolDialog",
  components: { ErrorButton, PrimaryButton, BaseDialog },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapState({
      currentTalentPool: state => state.currentTalentPool
    })
  },
  methods: {
    ...mapActions({
      removeTalentPool: REMOVE_TALENT_POOL
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.removeTalentPool(this.currentTalentPool.id);
      this.onSuccess();
      this.isLoading = false;
    },
    close() {
      this.$emit("close");
    },
    onSuccess() {
      this.$router.push("/talentpools");
    }
  }
};
</script>

<style></style>
